import React, { useState } from 'react'
import { Image } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useHistory } from 'react-router-dom';
const JckpopUpImg = require('../../Assets/images/jck-popup-img25.webp')

const JckPopUp = () => {
  const history = useHistory();
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  return (
    <div className='jck-popup_section'>
      <Modal size='lg' centered show={show} onHide={handleClose} className='jck_pop_up_modal_header' >
        <Modal.Header closeButton className='p-0  border-bottom-0'>
        </Modal.Header>
        <Modal.Body className='p-0' onHide={handleClose}>
          <Image src={JckpopUpImg} alt='JCK Image' onClick={() => {
            handleClose();
            history.push('/jck');
          }} className='img-fluid jck_pop_up_modal_img' style={{ cursor: 'pointer' }} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default JckPopUp